import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_2 = { class: "flex flex-row items-stretch justify-between w-full" }
const _hoisted_3 = { class: "flex items-center justify-end gap-5 w-full mt-5" }
const _hoisted_4 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_5 = { class: "text-center py-5" }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Step = _resolveComponent("Step")
  const _component_StepList = _resolveComponent("StepList")
  const _component_BankDetail = _resolveComponent("BankDetail")
  const _component_StepPanel = _resolveComponent("StepPanel")
  const _component_StepPanels = _resolveComponent("StepPanels")
  const _component_Toast = _resolveComponent("Toast")
  const _component_Stepper = _resolveComponent("Stepper")

  return (_ctx.isBankUpdate)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-gray-800 text-xl font-bold" }, "อัปเดตบัญชี", -1 /* HOISTED */)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-[12px] mt-2" }, "กรุณาอัปเดตบัญชีธนาคาร", -1 /* HOISTED */)),
        _createVNode(_component_Button, {
          label: "อัปเดตบัญชี",
          onClick: _ctx.btnClickUpdateBank,
          class: "bg-[#753a13]! border-0! mt-4",
          size: "small"
        }, null, 8 /* PROPS */, ["onClick"])
      ]))
    : (_openBlock(), _createBlock(_component_Stepper, {
        key: 1,
        value: _ctx.stepper,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.stepper) = $event)),
        linear: "",
        pt: {separator:'bg-[#753a13]!'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StepList, null, {
            default: _withCtx(() => [
              _createVNode(_component_Step, {
                value: "1",
                pt: {header: 'text-xs!', number: 'text-gray-800! text-xs! size-6! min-w-auto!', title:'text-gray-800!'}
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("ฝาก")
                ])),
                _: 1 /* STABLE */,
                __: [4]
              }),
              _createVNode(_component_Step, {
                value: "2",
                pt: {header: 'text-xs!', number: 'text-gray-800! text-xs! size-6! min-w-auto!', title:'text-gray-800!'}
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("สำเร็จ")
                ])),
                _: 1 /* STABLE */,
                __: [5]
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_StepPanels, { pt: {root: 'px-0!'} }, {
            default: _withCtx(() => [
              _createVNode(_component_StepPanel, {
                value: "1",
                pt: {root: 'bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  (_ctx.isActive)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg-white border-2! border-[#ff8a1f]! rounded-3xl mb-3 p-2" }, [
                          _createElementVNode("p", { class: "text-gray-800 text-[16px]" }, "⚠️ ฝากถอน ขั้นต่ำ 100 บาท"),
                          _createElementVNode("p", { class: "text-gray-800 text-[14px] py-2" }, "โอนเงินจากบัญชี TrueWallet ของคุณ ไปยังบัญชีที่แสดง เงินจะเติมเข้า กระเป๋าเกม ภายใน 5 วินาที")
                        ], -1 /* HOISTED */)),
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_BankDetail, {
                            isActivate: _ctx.bankAccount.active,
                            loading: _ctx.bankAccount.loading,
                            bank: _ctx.bankAccount.data
                          }, null, 8 /* PROPS */, ["isActivate", "loading", "bank"]),
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center w-max" }, [
                            _createElementVNode("svg", {
                              class: "text-gray-800",
                              "aria-hidden": "true",
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              fill: "none",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                stroke: "currentColor",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 12H5m14 0-4 4m4-4-4-4"
                              })
                            ])
                          ], -1 /* HOISTED */)),
                          _createVNode(_component_BankDetail, {
                            isActivate: _ctx.bankDeposit.active,
                            loading: _ctx.bankDeposit.loading,
                            isCopyNumber: true,
                            bank: _ctx.bankDeposit.data
                          }, null, 8 /* PROPS */, ["isActivate", "loading", "bank"])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_Button, {
                            onClick: _cache[0] || (_cache[0] = $event => (_ctx.stepper = '2')),
                            size: "small",
                            label: "ถัดไป",
                            disabled: (!_ctx.bankAccount.active) || (!_ctx.bankDeposit.active),
                            class: "bg-[#753a13]! border-0!"
                          }, null, 8 /* PROPS */, ["disabled"])
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[8] || (_cache[8] = [
                        _createElementVNode("h2", { class: "text-gray-800 text-xl font-bold" }, "ปิดให้บริการชั่วคราว", -1 /* HOISTED */),
                        _createElementVNode("p", { class: "text-[12px] text-gray-800 mt-2" }, "ช่องทางฝากนี้ปิดให้บริการชั่วคราว กรุณาลองช่องทางอื่น ๆ", -1 /* HOISTED */)
                      ])))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_StepPanel, {
                value: "2",
                pt: {root: 'bg-transparent!'}
              }, {
                default: _withCtx(({ activateCallback }) => [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-gray-800 text-xl font-bold" }, "เมื่อทำการโอนเงินเรียบร้อยแล้ว", -1 /* HOISTED */)),
                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-gray-800 mt-2" }, "ยอดเงินจะถูกเติมเข้า กระเป๋าเกม ภายใน 5 วินาที", -1 /* HOISTED */)),
                    _createVNode(_component_Button, {
                      label: "กลับหน้าหลัก",
                      onClick: $event => (activateCallback('1')),
                      class: "bg-[#753a13]! border-0! mt-4"
                    }, null, 8 /* PROPS */, ["onClick"])
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Toast)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value"]))
}